import React from 'react';

export const healText = (
	<>
		<p>
			Healing from a pet’s loss, including how long you grieve, is an individual process. Some people fear that moving past their grief means
			they are being disloyal to their pet. But moving forward is natural, and does not mean you love or miss your pet any less. You will carry
			your pet in your heart as you move forward.
		</p>
		<p>
			You will know when you are beginning to heal. As the adage says, time mends a broken heart, and your love for your pet will begin to
			outweigh the sadness of their loss. You will be able to fondly remember good times with your pet, their unique personality quirks, and
			their smile. We are sharing these resources to help you during your healing journey, with ways to memorialize your pet when you feel
			ready.
		</p>
	</>
);

export const movingTitle = 'Moving Forward';
// eslint-disable-next-line max-len
export const movingText = 'As you begin to heal, it can be helpful to engage with other people in a variety of ways. Support groups, social activities, and community service can all help with the healing process. We find that getting out in your community and donating time can be therapeutic, and helps many of our clients heal. If you feel ready for this step, consider volunteering at a local hospital, museum, zoo, aquarium, animal shelter, rescue group, or nursing home. You might also consider certifying your surviving pet as a therapy pet, and volunteering together at hospitals or nursing homes. Your service can be animal-focused, as a tribute to your pet, or completely unrelated.';

export const resourcesTitle = (
	<>
		<h3 className="rich-text__title">Resources</h3>
	</>
);

export const resourcesList = [
	{
		url: 'https://www.aplb.org/',
		title: 'The Association for Pet Loss and Bereavement',
	},
	{
		url: 'https://www.centerforloss.com/grief/grief-mourning-basics/',
		title: 'Center for Loss and Life Transition',
	},
	{
		url: 'https://www.rainbowsbridge.com/grief_support_center/grief_support_home.htm',
		title: 'Grief Support Center at Rainbows Bridge',
	},
];
export const communityTitle = (
	<>
		<h3 className="rich-text__title">You can identify opportunities to engage with others in your community through:</h3>
	</>
);

export const communityList = [
	{
		url: 'https://www.volunteermatch.org/',
		title: 'VolunteerMatch',
		description: 'This national database will help you find a variety of volunteer opportunities in your local community.',
	},
	{
		url: '',
		title: 'Helping others in need',
		// eslint-disable-next-line max-len
		description: 'Sometimes the best way to heal is by helping others who are going through a similar experience. Helping someone else who is struggling reminds you that you are not alone, which can help provide relief. Helping others who are struggling with pet loss also can help you—and them—move forward. ',
	},
	{
		url: 'https://www.facebook.com/lapoflove/',
		title: 'Joining a Facebook group',
		// eslint-disable-next-line max-len
		description: 'Endless Facebook groups can help you bond with like-minded people. Whether you join a local or national group, discussing topics you are passionate about can bring you closer to others. ',
	},
];
